import React, { PureComponent } from 'react';
import { encodeForURI } from 'appSrc/utils';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import TextTruncate from 'react-text-truncate';
import ArticleCoverImage from 'appSrc/components/Article/CoverImage';
import style from './styles/style.module.css';


class ArticleRowItem extends PureComponent {
    constructor(props) {
        super(props);
    }
    convertHTMLString = ( input ) => {
        var output = input.replace( /<[^>]*>/gm, '' );
        return output;
    }

    render() {
        const { article } = this.props;
        const articleSlug = `/app/articles/${ article.id }/${ encodeForURI(article.title) }`;
        const text = this.convertHTMLString( article.primary_text );

        return (
            <div
            className={ `${ style.articleRowItem } ${ this.props.className }` }
            style={ { ...this.props.style } }
            data-hook='article-row-item'>
                <Link to={ articleSlug }>
                    <div className={ style.imageWrapper }>
                        <ArticleCoverImage coverImage={ article.cover_image } videoId={ article.video_url } />
                    </div>
                    <div className={ style.details }>
                        <div className={ style.articleTitle } title={ article.title }>{ article.title }</div>
                        <TextTruncate line={ 2 }
                        containerClassName={ style.articleDescription }
                        text={ text } />

                    </div>
                </Link>
            </div>
        );
    }
}
ArticleRowItem.propTypes = {
    article: PropTypes.object.isRequired,
};

export default connect()( ArticleRowItem );
